// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export default {
  'mifos_x': {
    'version': '250530',
    'hash': 'd91c545c'
  },
  'allow_switching_backend_instance': true
};
/* tslint:enable */
